import React,{useEffect} from 'react';
import HeaderSec from '../components/HeaderSec';
import Footer from '../components/Footer';
import PaymentMethods from '../components/PaymentMethods';
import WhatsappChat from '../components/WhatsappChat';
import ScrollTop from '../components/ScrollTop';
import ContactIcon from '../components/ContactIcon';
import CookiesPopup from '../components/CookiesPopup';

import Title from "../components/Title";
import ServicesBanner from '../components/ourservices/ServicesBanner';
import ServicesCards from '../components/ourservices/ServicesCards';
import ContactUs from '../components/ContactUs';

const Ourservices = () => {
    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant"
        });
      }, []);
        return(
            <>
            <Title title="Services | CAD AND RENDER" />
            <HeaderSec />

            <ContactIcon />
            <WhatsappChat />
            <ScrollTop />
            <CookiesPopup />

            <ServicesBanner />

            <div className='cadAboutContent'>
                <div className='container'>
                    <p>At CAD and RENDER, we specialize in providing high-quality jewelry 3D CAD Designing and Realistic Rendering services to jewelry manufacturers, wholesalers and retailers. With years of experience in the industry, we have become experts in our craft and are dedicated to providing exceptional service to our clients.</p>
                </div>
            </div>

            <ServicesCards />

            <ContactUs />

            <PaymentMethods />

            <Footer />
            </>
        )
}


export default Ourservices;